module.exports = __webpack_public_path__ + "img/icon-user-invite.adfd34dd.svg";